<!--
 * @Author: youthscc(蒋松)
 * @Date: 2024-10-15 10:18:02
 * @LastEditors: youthscc(蒋松)
 * @LastEditTime: 2024-10-16 18:35:48
-->
<template>
  <Modal center width="400px" v-model="show" @on-cancel="handleCancel">
    <template #header>
      <h2>身份验证</h2>
    </template>
    <div>切换企业需要进行身份验证，点击发送验证码到您的手机{{ showTitle }}</div>
    <CaptchaInput ref="codeRef" v-model="code" :type="'mobile'" :userInfo="userInfo" />
    <template #footer>
      <div>
        <Button @click="handleCancel" ghost type="primary">取消</Button>
        <Button :disabled="loading" @click="handleOk" type="primary">确认</Button>
      </div>
    </template>
  </Modal>
</template>
<style lang="less"></style>
<script setup>
import { ref, onMounted, defineProps, defineEmits, watch } from 'vue'
import CaptchaInput from './CaptchaInput.vue'
import platform from '../../data/platform'
import { Modal, Button, Message } from 'view-ui-plus'

const props = defineProps({
  modelValue: Boolean,
  targetPartnerId: Number
})
const codeRef = ref(null)
watch(() => props.modelValue, (val) => {
  show.value = val
  codeRef.value && codeRef.value.clearCode()
})

const emit = defineEmits(['update:modelValue', 'success'])
const code = ref('')
const userInfo = ref({})
const showTitle = ref('')
const loading = ref(false)
const show = ref(false)
onMounted(async () => {
  const res = await window.$ZConfig.getCurUserInfo()
  userInfo.value = res && res.userDto
  const { mobile } = userInfo.value
  showTitle.value = mobile && mobile.replace(/(\d{3})\d{4}(\d+)/, '$1****$2')
  show.value = props.modelValue
})

const handleCancel = () => {
  emit('update:modelValue', false)
}

const handleOk = window._.debounce(async () => {
  console.log('code ~ 🚀 ', code.value);
  if (!code.value) {
    Message.warning('请输入短信验证码')
    return
  }
  loading.value = true
  const res = await platform.switchPartner({
    code: code.value,
    targetPartnerId: props.targetPartnerId
  })
  loading.value = false
  const { data } = res
  if (data.code === '0') {
    const { result, pcAutoLoginUrl } = data.data
    if (result && pcAutoLoginUrl) {
      handleCancel()
      emit('success', pcAutoLoginUrl)
    } else {
      Message.warning('验证码不匹配')
    }
  } else {
    Message.warning(data.msg || '服务出错了')
  }
}, 300)
</script>